// extracted by mini-css-extract-plugin
module.exports = {"PillTheme__pill__3Q4KS":"PillTheme__pill__3Q4KS"};